import axios from "axios";
/**
 * NHL API
 *
 * https://gitlab.com/dword4/nhlapi
 *
 */
const rest = axios.create({
    baseURL: 'https://statsapi.web.nhl.com/api/v1',
    headers: {}
});
export var NhlApi;
(function (NhlApi) {
    NhlApi.api = {
        getTeams: () => {
            return rest.get('/teams').then(response => response.data);
        },
    };
})(NhlApi || (NhlApi = {}));
